import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { SERVICES_GRID } from '../../data/site';
import { Reveal } from '../common/Reveal';

export const ServicesGrid = ({ title = 'Roofing Services At Affordable Prices' }) => (
  <section className="relative py-24 bg-dark overflow-hidden" data-testid="services-grid-section">
    <div
      className="absolute -top-40 -left-24 w-[480px] h-[480px] rounded-full opacity-15 blur-3xl pointer-events-none"
      style={{ background: 'var(--gradient-fire)' }}
    />
    <div className="relative max-w-[1320px] mx-auto px-4 lg:px-8">
      <Reveal className="text-center max-w-2xl mx-auto">
        <span className="eyebrow justify-center !text-[hsl(var(--primary-glow))]">What We Do</span>
        <h2 className="section-title mt-4 text-dark-foreground" data-testid="services-grid-title">{title}</h2>
        <p className="mt-5 text-lg text-dark-foreground/70">
          Complete exterior services for your home — from the roof deck to the gutters, done right the first time.
        </p>
      </Reveal>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mt-14">
        {SERVICES_GRID.map((s, i) => (
          <Reveal key={s.title} delay={(i % 3) * 0.08}>
            <Link
              to={s.path}
              className="group h-full rounded-2xl bg-card p-8 flex flex-col card-lift"
              data-testid={`service-card-${s.title.toLowerCase().replace(/[^a-z]+/g, '')}`}
            >
              <img src={s.icon} alt={s.title} className="h-16 w-16 object-contain" loading="lazy" />
              <h3 className="font-heading font-bold text-xl mt-5">{s.title}</h3>
              <p className="mt-2.5 text-muted-foreground text-[15px]">{s.text}</p>
              <span className="mt-auto pt-5 inline-flex items-center gap-1.5 font-heading font-bold text-sm text-primary">
                Learn more <ArrowRight className="w-4 h-4 transition-transform duration-200 group-hover:translate-x-1" />
              </span>
            </Link>
          </Reveal>
        ))}
      </div>

      <Reveal className="text-center mt-14">
        <Link to="/free-estimate" className="btn-cta" data-testid="services-grid-cta">
          Request a Free In-House Estimate <ArrowRight className="w-4 h-4" />
        </Link>
      </Reveal>
    </div>
  </section>
);
